import _ from 'lodash'
import Bus from '../bus'

export function add_canvas(state) {
	const max = state.keys.length ? (_.max(state.keys.map(item => +item)) + 1) : 1
	if (!state.tpl) state.tpl = {}
	state.tpl[String(max)] = { width: 0, height: 0, list: [] }
	Object.assign(state, {
		tpl: state.tpl,
		keys: state.keys.concat([String(max)])
	})
}

export function switch_canvas(state, { key }) {
	save_canvas(state)
	if (key) {
		Object.assign(state, {
			canvas: state.tpl[key].list || [],
			activeKey: key,
			designWidth: state.tpl[key].width || 0,
			designHeight: state.tpl[key].height || 0
		})
	}
}

export function remove_canvas(state, { key }) {
	save_canvas(state)

	if (key) {
		const keys = state.keys.filter(item => item !== key)
		if (state.activeKey === key) {
			if (keys[0]) {
				switch_canvas(state, { key: keys[0] })
			}
		}
		delete state.tpl[key]
		Object.assign(state, {
			canvas: state.tpl[state.activeKey].list || [],
			keys,
			tpl: state.tpl,
			activeKey: state.activeKey,
			designWidth: state.tpl[state.activeKey].width || 0,
			designHeight: state.tpl[state.activeKey].height || 0
		})
	}
}


export function save_canvas(state) {
	if (state.activeKey) {
		const template = state.tpl
		if (!template[state.activeKey]) {
			template[state.activeKey] = {}
		}
		template[state.activeKey].list = state.canvas
		template[state.activeKey].width = state.designWidth
		template[state.activeKey].height = state.designHeight
		Object.assign(state, {
			tpl: template
		})
	}
}

export function load_template(state, { fileContent }) {
	if (!state.keys.length) {
		add_canvas(state)
		state.activeKey = "1"
	}
	const list = (fileContent.list || []).map((item) => {
		const { minPoint, maxPoint, rotate = 0, ...data } = item
		const width = maxPoint.x - minPoint.x
		const height = maxPoint.y - minPoint.y
		return {
			id: Math.random(),
			width,
			height,
			x: minPoint.x + width / 2,
			y: minPoint.y + height / 2,
			rotate,
			...data
		}
	})
	Object.assign(state, {
		selected: {},
		canvas: list,
		scaleRate: 500 / fileContent.height,
		designWidth: fileContent.width || 400,
		designHeight: fileContent.height || 300
	})
	set_history(state, { canvas: list })
}

export function load_video(state, data) {
	if (typeof data.template_type === 'undefined' && data.type === 1 || data.template_type === 1) {
		const tpl = data.content
		if (tpl.outputDesc.bgColor) {
			tpl.outputDesc.bgColor = tpl.outputDesc.bgColor.replace(/RGBA\((\d+,\d+,\d+,)(\d+)\)/, function () {
				return "rgba(" + arguments[1] + (+arguments[2] / 255) + ")"
			})
		}
		Object.assign(state, {
			selected: {},
			scaleRate: 500 / tpl.outputDesc.height,
			designWidth: tpl.outputDesc.width,
			designHeight: tpl.outputDesc.height,
			outputDesc: tpl.outputDesc,
			actions: tpl.actions || [],
			elements: tpl.elements || [],
			resource: tpl.resource || {},
			slots: data.config || []
		})
	} else {
		const tpl = data.ae_content || { 'bgmusic': '', 'snapshotTime': 0 }
		Object.assign(state, {
			selected: {},
			scaleRate: 1,
			task_api_response: data.task_api_response,
			ae_type: data.ae_type,
			ae_tpl: tpl,
			elements: tpl.userElements || [],
			slots: data.config || []
		})
	}
}

export function elm_move_top(state, { id }) {
	const selected = id
	const list = state.canvas || []
	const index = (list || []).findIndex(item => item.id === selected)
	if (index < list.length - 1) {
		const elm = list[index]
		list.splice(index, 1)
		list.splice(list.length, 0, elm)
	}
	Object.assign(state, {
		canvas: list,
		selected: {}
	})
	push_history(state, { canvas: list })
}

export function elm_move_bottom(state, { id }) {
	const selected = id
	const list = state.canvas || []
	const index = (list || []).findIndex(item => item.id === selected)
	if (index > 0) {
		const elm = list[index]
		list.splice(index, 1)
		list.splice(0, 0, elm)
	}
	Object.assign(state, {
		canvas: list,
		selected: {}
	})
	push_history(state, { canvas: list })
}

export function elm_move_up(state, { id }) {
	const selected = id
	const list = state.canvas || []
	const index = (list || []).findIndex(item => item.id === selected)
	if (index < list.length - 1) {
		const elm = list[index]
		list.splice(index, 1)
		list.splice(index + 1, 0, elm)

	}
	Object.assign(state, {
		canvas: list,
		selected: {}
	})
	push_history(state, { canvas: list })
}

export function elm_move_down(state, { id }) {
	const selected = id
	const list = state.canvas || []
	const index = (list || []).findIndex(item => item.id === selected)
	if (index > 0) {
		const elm = list[index]
		list.splice(index, 1)
		list.splice(index - 1, 0, elm)
	}
	Object.assign(state, {
		canvas: list,
		selected: {}
	})
	push_history(state, { canvas: list })
}


export function elm_remove(state, { id }) {
	const selected = id
	if (selected === undefined) {
		return
	}
	const list = state.canvas || []
	const index = (list || []).findIndex(item => item.id === selected)
	list.splice(index, 1)
	Object.assign(state, {
		canvas: list,
		selected: {}
	})
	push_history(state, { canvas: list })
}

export function update(state, payload) {
	Object.assign(state, payload)
}

export function update_selected(state, payload) {
	let selected = Object.assign({}, state.selected, payload)
	Object.assign(state, {
		selected
	})
}

export function update_elm(state, { id, data }) {
	let canvas = Object.assign([], state.canvas)
	const elm = canvas.find(item => item.id === id) || {}
	Object.assign(elm, data)
	Object.assign(state, { canvas })

	if (typeof data.width === 'undefined'
		&& typeof data.height === 'undefined'
		&& typeof data.x === 'undefined'
		&& typeof data.y === 'undefined'
		&& typeof data.rotate === 'undefined'
	) {
		push_history(state, { canvas })
	}
}

export function update_elm_style(state, { id, data }) {
	let canvas = Object.assign([], state.canvas)
	const elm = canvas.find(item => item.id === id)
	let style = Object.assign({}, elm.style, data)
	Object.assign(elm, { style })
	let selected = Object.assign(state.selected, { style })
	Object.assign(state, {
		selected,
		canvas
	})
}

export function switchMenu(state, { type }) {
	state.activeMenu = type
}


export function toggle_resource_panel(state, { status }) {
	state.resource_panel_status = status
}


export function set_history(state, { canvas }) {
	state.history = []
	state.history.push(_.cloneDeep(canvas))
	state.history_wind = 0
}

export function push_history(state, { canvas }) {
	let record = _.cloneDeep(canvas)
	state.history = state.history.slice(0, state.history_wind + 1)
	state.history.push(record)
	state.history_wind++
	if (state.history.length > 50) {
		state.history.splice(0, 1)
		state.history_wind--
	}
}

export function undo_history(state) {
	state.selected = {}
	if (state.history_wind > 0) {
		state.history_wind--
		state.canvas = _.cloneDeep(state.history[state.history_wind])
	}
}

export function redo_history(state) {
	state.selected = {}
	if (state.history_wind < state.history.length - 1) {
		state.history_wind++
		state.canvas = _.cloneDeep(state.history[state.history_wind])
	}
}

export function update_scale(state, { value }) {
	state.scaleRate = value / 100
}


function key_move(state, k, v) {
	const selected = state.selected.id
	const list = state.canvas || []
	const index = (list || []).findIndex(item => item.id === selected)
	list[index][k] += v
	state.selected[k] = list[index][k]
	Object.assign(state, {
		canvas: list,
		selected: state.selected
	})
	push_history(state, { canvas: list })
}

export function move_short_up(state) {
	key_move(state, 'y', -1)
}

export function move_short_right(state) {
	key_move(state, 'x', 1)
}

export function move_short_down(state) {
	key_move(state, 'y', 1)
}

export function move_short_left(state) {
	key_move(state, 'x', -1)
}

export function move_large_up(state) {
	key_move(state, 'y', -10)
}

export function move_large_right(state) {
	key_move(state, 'x', 10)
}

export function move_large_down(state) {
	key_move(state, 'y', 10)
}

export function move_large_left(state) {
	key_move(state, 'x', -10)
}

export function update_action(state, { name, ...payload }) {
	const actionIndex = state.actions.findIndex(item => item.name === name)
	if (actionIndex > -1) {
		Object.assign(state.actions[actionIndex], payload)
	}
}

export function update_resource(state, payload) {
	Object.assign(state.resource, payload)
}

export function update_element(state, { id, data }) {
	const act = state.actions.find(item => item.element + '_' + item.name === id)
	const elmIndex = state.elements.findIndex(item => item.name === act.element)
	if (elmIndex > -1) {
		Object.assign(state.elements[elmIndex], data)
	}
}

export function update_action_style(state, { id, ...payload }) {
	const act = state.actions.find(item => item.element + '_' + item.name === id)
	const elmIndex = state.elements.findIndex(item => item.name === act.element)
	if (elmIndex > -1) {
		Object.keys(payload).forEach((key) => {
			if (state.elements[elmIndex][key]) {
				Object.assign(state.elements[elmIndex][key], payload[key])
				Object.assign(state.selected.style, payload[key])
			}
		})
	}
}

export function action_remove(state, { id }) {
	const actIndex = state.actions.findIndex(item => item.element + '_' + item.name === id)
	state.actions.splice(actIndex, 1)
	state.activeAction = null
}

export function set_action_dynamic(state, { id, isDynamic }) {
	const act = state.actions.find(item => item.element + '_' + item.name === id)
	const index = state.slots.findIndex(item => item.name === `##${act.element}`)
	const slots = state.slots || []
	if (isDynamic === 1 && index <= -1) {
		slots.push({
			name: '##' + act.element,
			type: 'image'
		})
	} else if (isDynamic === 0 && index > -1) {
		slots.splice(index, 1)
	}
	Object.assign(state.slots, slots)
}


export function update_ae_elm(state, { name, ...payload }) {
	var index = state.elements.findIndex((item) => {
		return item.name === name
	})

	if (index >= 0) {
		Object.assign(state.elements[index], payload)
	}
}

export function update_ae_dynamic(state, { name, isDynamic }) {
	const elm = state.elements.find((item) => {
		return item.name === name
	})
	const index = state.slots.findIndex(item => item.name === `##${name}`)
	const slots = state.slots || []
	if (isDynamic && index <= -1) {
		slots.push({
			name: '##' + name,
			type: elm.type === '.mp4' ? 'video' : 'image'
		})
	} else if (!isDynamic && index > -1) {
		slots.splice(index, 1)
	}
	Object.assign(state.slots, slots)
}

export function update_ae_music(state, { url }) {
	Object.assign(state.ae_tpl, {
		bgmusic: url
	})
}
export function update_ae_time(state, { time }) {
	Object.assign(state.ae_tpl, {
		snapshotTime: time
	})
}
